/* eslint-disable */

import React, { useCallback, useState } from "react";
import { IconButton, Tooltip } from "@mui/material";
import VisibilityIcon from "@material-ui/icons/Visibility";
import EditIcon from "@material-ui/icons/Edit";
import { AddBox } from "@material-ui/icons";
import PlanDesignFormDialog from "./addPlanDesign/AddPlanDialog";
import { PlanDesignFormData } from "../../../../../../@types/planDesignForm.types";
import { trackPromise } from "react-promise-tracker";
import { api } from "../../../../../../utils/api";
import { text } from "d3";
import { plan } from "../../../../../../utils/api/plan/plan";

const PlanDesignFormCellRenderer: React.FC<any> = (params) => {
	const { data } = params; // row data
	const [openFormDialog, setOpenFormDialog] = useState(false);
	const [formMode, setFormMode] = useState<"view" | "edit" | "add">("view");

	const handleOpenDialog = (mode: "view" | "edit" | "add") => {
		setFormMode(mode);
		setOpenFormDialog(true);
	};

	const handleCloseDialog = () => setOpenFormDialog(false);

	const handlePlanFormDesignAdd = useCallback(
		async (formData: PlanDesignFormData) => {
			// console.log(`${formMode.toUpperCase()} Plan Submitted:`, formData);
			// TODO: call backend API to save/edit/add

			const planFormDesignPayload = {
				plan_code: data.plan_code,
				plan_name: data.plan_name,
				group_number: data.group_number,
				form_design: {
					textual_details: formData.form_design.textual_details
				},
				branding_design: {
					textual_details: formData.branding_design.textual_details
					// logo: formData.branding_design.logo,
					// image: formData.branding_design.image
				}
			};
			// console.log("terminatePlanPayload", terminatePlanPayload);

			const formDataPayload: FormData = new FormData();
			formDataPayload.append("planDesign", JSON.stringify(planFormDesignPayload));
			// formDataPayload.append("logo", formData.branding_design.logo as unknown as File);
			// formDataPayload.append("image", formData.branding_design.image as unknown as File);

			if (formData.branding_design.logo instanceof File) {
				formDataPayload.append("logo", formData.branding_design.logo as unknown as File);
			}
			if (formData.branding_design.image instanceof File) {
				formDataPayload.append("image", formData.branding_design.image as unknown as File);
			}

			try {
				const plan = await trackPromise(api.planDesign.addPlanDesignForm(formDataPayload));
				if (plan) {
					alert("Succesfully plan Form Design added");
					window.location.reload();
				}
			} catch (error) {
				alert(error);
			}

			setOpenFormDialog(false);
		},
		[formMode, data]
	);
	const handlePlanFormDesignUpdate = useCallback(
		async (formData: PlanDesignFormData) => {
			const formDataPayload: FormData = new FormData();

			const planFormDesignPayload = {
				plan_code: data.plan_code,
				plan_name: data.plan_name,
				group_number: data.group_number,
				form_design: {
					textual_details: formData.form_design.textual_details,
					form_declaration: formData.form_design.form_declaration
				},
				branding_design: {
					textual_details: formData.branding_design.textual_details
					// logo: formData.branding_design.logo,
					// image: formData.branding_design.image
				}
			};
			formDataPayload.append("planDesign", JSON.stringify(planFormDesignPayload));
			if (formData.branding_design.logo instanceof File) {
				formDataPayload.append("logo", formData.branding_design.logo as unknown as File);
			}
			if (formData.branding_design.image instanceof File) {
				formDataPayload.append("image", formData.branding_design.image as unknown as File);
			}
			// Append any files if needed
			try {
				const plan = await trackPromise(api.planDesign.updatePlanDesignForm(formDataPayload));
				if (plan) {
					alert("Successfully plan Form Design updated");
					window.location.reload();
				}
			} catch (error) {
				alert(error);
			}
		},
		[data]
	);

	// For Add mode, pre-fill empty form with group_number, plan_name, plan_code from row data
	const initialData: PlanDesignFormData =
		formMode === "add"
			? {
					status: "ACTIVE",
					group_number: data.group_number,
					plan_name: data.plan_name,
					plan_code: data.plan_code,
					branding_design: { logo: null, image: null, textual_details: "" },
					form_design: { textual_details: "" }
			  }
			: // : formMode === "edit" || formMode === "view"
			// ? {
			// 		status: data.planDesign.status,
			// 		group_number: data.group_number,
			// 		plan_name: data.plan_name,
			// 		plan_code: data.plan_code,
			// 		branding_design: { logo: null, image: null, textual_details: "" },
			// 		form_design: { textual_details: "" }
			//   }
			data.planDesign
			? data.planDesign
			: data;

	return (
		<>
			{/* View Button */}
			{data.planDesign ? (
				<>
					<Tooltip title="View Form" arrow>
						<IconButton onClick={() => handleOpenDialog("view")}>
							<VisibilityIcon />
						</IconButton>
					</Tooltip>

					{/* Edit Button */}
					<Tooltip title="Edit Form" arrow>
						<IconButton onClick={() => handleOpenDialog("edit")}>
							<EditIcon />
						</IconButton>
					</Tooltip>
				</>
			) : (
				<>
					{/* Add Button */}
					<Tooltip title="Add Form" arrow>
						<IconButton onClick={() => handleOpenDialog("add")}>
							<AddBox />
						</IconButton>
					</Tooltip>
				</>
			)}

			{/* Plan Design Form Dialog */}
			{openFormDialog && (
				<PlanDesignFormDialog
					open={openFormDialog}
					onClose={handleCloseDialog}
					onSubmit={formMode === "edit" ? handlePlanFormDesignUpdate : handlePlanFormDesignAdd}
					initialData={initialData}
					mode={formMode}
				/>
			)}
		</>
	);
};

export default PlanDesignFormCellRenderer;
